"use client";

import { useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../../lib/firebase";
import LoginPage from "./(auth)/login/page";

export default function HomeClient() {
  // Register service worker
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/firebase-messaging-sw.js");
    }
  }, []);

  // Auto permission + token
  useEffect(() => {
    initNotification();
  }, []);
   const initNotification = async () => {
      if (!messaging) return;

      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: "BPOS8DeUHjVzNVpD2KpqSeU5TUKsinoXLmQVQoObqZWFAW-ntIiVBx49FrNI4egOdZC73-1rvR-6hTndFctOV34",
        });
        console.log("FCM Token:", token);
      }
    };

  // Foreground messages
  useEffect(() => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
        console.log(payload)
      alert(
        payload.notification?.title + " - " + payload.notification?.body
      );
    });
  }, []);

  return <LoginPage />;
}
